import { useLayoutEffect } from 'react';
import useScrollbarSize from 'react-scrollbar-size';

export default function useScrollbarWidth() {
  const { width } = useScrollbarSize();

  useLayoutEffect(() => {
    document.documentElement.style.setProperty(
      '--scrollbar-width',
      width + 'px'
    );
  }, [width]);
}
